import type { ChaliceStore } from '../types';

export const selectNudges = (state: ChaliceStore) => state.nudges.nudges;

export const selectCanShowNudges = (state: ChaliceStore) =>
  state.nudges.currentNudgeIndex === 0 ||
  state.nudges.currentNudgeIndex <= state.nudges.nudges.length;
